import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router";
import { ArrowLeft, Phone, X } from "lucide-react";
import { API, LOGO_IMAGE } from "./data";

export default function PostsPage() {
  const [posts, setPosts] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => { setPosts(data); setLoaded(true); }).catch(() => setLoaded(true));
  }, []);

  return (
    <div className="site-shell posts-page">
      <div className="topline"><div className="container top-inner"><span>Patient education posters</span><a data-testid="posts-phone-link" href="tel:7780793371"><Phone size={14} /> 7780793371</a></div></div>
      <header className="nav container">
        <Link className="brand" to="/" aria-label="Back to homepage"><img className="brand-logo" src={LOGO_IMAGE} alt="Dr. Sreeniketh Reddy — Urologist, Andrologist and Robotic Surgeon" /></Link>
        <Link className="button button-outline nav-cta" data-testid="posts-back-link" to="/"><ArrowLeft size={16} /> Back to homepage</Link>
      </header>
      <main className="container posts-main">
        <div className="section-label"><span className="chapter-no">01</span>Health posts</div>
        <div className="section-head"><h1 className="posts-title">Patient education, one poster at a time.</h1><p>Simple, reliable health notes from Dr. Sreeniketh Reddy — share them with anyone who might benefit.</p></div>
        {!loaded ? <p className="admin-empty">Loading…</p> :
          posts.length === 0 ? <p className="admin-empty" data-testid="posts-empty">New health posts are on the way — check back soon.</p> :
          <div className="posts-grid" data-testid="posts-grid">
            {posts.map((post, index) => (
              <button className="posts-item" key={post.id} data-testid={`posts-item-${index}`} onClick={() => setOpenIndex(index)}>
                <img src={`${API}/gallery/image/${post.storage_path}`} alt={post.caption} loading="lazy" />
              </button>
            ))}
          </div>}
      </main>
      {openIndex !== null && posts[openIndex] && (
        <div className="lightbox-backdrop" data-testid="posts-lightbox" onClick={() => setOpenIndex(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close lightbox-close" data-testid="posts-lightbox-close" onClick={() => setOpenIndex(null)}><X /></button>
            <img data-testid="posts-lightbox-image" src={`${API}/gallery/image/${posts[openIndex].storage_path}`} alt={posts[openIndex].caption} />
          </div>
        </div>
      )}
    </div>
  );
}
